function initGlytoneFinalCta(root) {
  if (!root || root.dataset.finalCtaInitialized === 'true') return;

  root.dataset.finalCtaInitialized = 'true';

  const sticky = root.querySelector('[data-mobile-sticky-cta]');
  const hero = document.querySelector('.glytone-hero');

  if (!sticky) return;

  const updateSticky = () => {
    if (window.innerWidth >= 990) {
      sticky.classList.remove('is-visible');
      return;
    }

    const finalRect = root.getBoundingClientRect();

    const finalCtaVisible =
      finalRect.top < window.innerHeight &&
      finalRect.bottom > 0;

    let heroPassed = true;

    if (hero) {
      const heroRect = hero.getBoundingClientRect();
      heroPassed = heroRect.bottom <= 0;
    } else {
      heroPassed = window.scrollY > 500;
    }

    if (heroPassed && !finalCtaVisible) {
      sticky.classList.add('is-visible');
    } else {
      sticky.classList.remove('is-visible');
    }
  };

  updateSticky();

  window.addEventListener('scroll', updateSticky, {
    passive: true
  });

  window.addEventListener('resize', updateSticky);
}

function initAllGlytoneFinalCtas(scope = document) {
  scope
    .querySelectorAll('[data-glytone-final-cta]')
    .forEach(initGlytoneFinalCta);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAllGlytoneFinalCtas();
  });
} else {
  initAllGlytoneFinalCtas();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllGlytoneFinalCtas(event.target);
});